import { observer } from 'mobx-react-lite'
import { BulkCopyJobsDialog } from '@/features/jobs/list/components/BulkCopyJobsDialog'
import { type BulkCopyJobsDialogViewModel } from './BulkCopyJobsDialogViewModel'

export interface BulkCopyJobsDialogContainerProps {
  vm: BulkCopyJobsDialogViewModel
}

export const BulkCopyJobsDialogContainer = observer(
  function BulkCopyJobsDialogContainer({
    vm,
  }: BulkCopyJobsDialogContainerProps) {
    return (
      <BulkCopyJobsDialog
        showing={vm.modal.showing}
        jobsCount={vm.jobsCount}
        isCopyPending={vm.copyJobs.pending}
        onClose={vm.modal.close}
        onCopy={vm.copyJobs}
      />
    )
  },
)
